import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, Inject, Input, Type } from '@angular/core';
import { ModalService } from '@indice/ng-components';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { RequestCallbackModalComponent } from '../request-callback-modal/request-callback-modal.component';
import { User } from 'oidc-client-ts';
import { IAsideModalResponse } from 'src/app/features/property-details/aside-content/aside-content.component';
import { ToasterService, ToastType } from 'src/app/services/toaster.service';
import { tap } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { PropertyDetails } from 'src/app/services/portal-api.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GeneralCallbackModal } from '../general-callback-modal/general-callback-modal.component';

const modalComponentMap: Record<string, Type<any>> = {
  'RequestCallbackModalComponent': RequestCallbackModalComponent,
  'GeneralCallbackModal': GeneralCallbackModal,
};
@Component({
  selector: 'app-experts-callback',
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
  templateUrl: './experts-callback.component.html',
  styleUrl: './experts-callback.component.css'
})
export class ExpertsCallbackComponent {
  @Input() property: PropertyDetails | undefined;
  /**
   * accept on of the below supported classes as string
   * 
   * 1. RequestCallbackModalComponent
   * 2. GeneralCallbackModal
   */
  @Input() modalComponent!: string; // Accepts a string (component identifier)
  @Input() isAob = false;

  private currentUser: User | null;

  constructor(
    private _authService: AuthService,
    private _modalService: ModalService,
    private _translocoService: TranslocoService,
    @Inject(ToasterService) private _toastService: ToasterService
  ) {
    this.currentUser = this._authService.getCurrentUser();
  }

  public onCallbackClick() {
    const modalComponentClass = modalComponentMap[this.modalComponent];
    if (!modalComponentClass) {
      console.error(`No component found for token: ${this.modalComponent}`);
      return;
    }
    const modal = this._modalService.show(modalComponentClass, {
      keyboard: true,
      class: 'h-dvh md:h-auto',
      initialState: {
        isLoggedIn: this.currentUser !== null,
        property: this.property,
      },
    });
    modal.onHidden?.pipe(
      tap((t: any) => {
        let input = t.result as IAsideModalResponse;
        if (input.success != undefined) {
          if (input.success == true) {
            const successTitle = this._translocoService.translate('experts.callback.success.title', {
              title: this.property ? this.property.title : "",
              address: this.property!.address ? this.property!.address.prefecture : ""
            });
            const successMessage = this._translocoService.translate('experts.callback.success.message', {
              advisor: this.property?.brokerName ?? '',
              phone: this.currentUser?.profile?.phone_number,
            });
            this._toastService.showBanner(ToastType.Success, successTitle, successMessage, 10000);
          } else {
            const errorTitle = this._translocoService.translate('experts.callback.error.title');
            const errorMessage = this._translocoService.translate('experts.callback.error.message', {
              errorDesc: input.errorDesc,
            });
            this._toastService.showBanner(ToastType.Error, errorTitle, errorMessage, 10000);
          }
        }
      })
    ).subscribe();
  }
}
